// Viewport intersection, including nested scrolling and the sticky W37 header.
export const isOnScreen = (element, top = 0) => {
  if (!element || !element.getClientRects().length) return false;
  const rect = element.getBoundingClientRect();
  let left = Math.max(0, rect.left);
  let right = Math.min(window.innerWidth, rect.right);
  let upper = Math.max(top, rect.top);
  let lower = Math.min(window.innerHeight, rect.bottom);
  for (let node = element; node; node = node.parentElement) {
    const style = window.getComputedStyle(node);
    if (node.hidden || style.display === 'none' || style.visibility === 'hidden' ||
        style.visibility === 'collapse' || style.opacity === '0') return false;
    if (node === element) continue;
    const bounds = node.getBoundingClientRect();
    if (/(auto|scroll|hidden|clip)/.test(style.overflowY)) {
      upper = Math.max(upper, bounds.top + node.clientTop);
      lower = Math.min(lower, bounds.top + node.clientTop + node.clientHeight);
    }
    if (/(auto|scroll|hidden|clip)/.test(style.overflowX)) {
      left = Math.max(left, bounds.left + node.clientLeft);
      right = Math.min(right, bounds.left + node.clientLeft + node.clientWidth);
    }
  }
  const head = element.closest('table')?.tHead;
  if (head && !head.contains(element) && window.getComputedStyle(head).position === 'sticky') {
    upper = Math.max(upper, head.getBoundingClientRect().bottom);
  }
  // A partially visible row is included; wholly clipped rows are not.
  return right > left && lower > upper;
};

// Separate adjacent number chips; textContent/innerText alone can turn 2, 4 into 24.
// Headers remain available as column labels even when hidden by the phone layout.
export const displayedText = (node, header = false) => {
  if (!node) return '';
  if (node.nodeType === 3) {
    const transform = node.parentElement && window.getComputedStyle(node.parentElement).textTransform;
    if (transform === 'uppercase') return node.textContent.toLocaleUpperCase();
    if (transform === 'lowercase') return node.textContent.toLocaleLowerCase();
    return node.textContent;
  }
  if (node.nodeType !== 1 || node.matches('svg, script, style, [data-w37-export-ignore]')) return '';
  const style = window.getComputedStyle(node);
  if (!header && (node.hidden || style.display === 'none' || style.visibility === 'hidden')) return '';
  const children = Array.from(node.childNodes);
  const isBlock = child => child?.nodeType === 1 && (child.tagName === 'BR' ||
    /^(block|flex|grid|table|list-item)/.test(window.getComputedStyle(child).display));
  return children.map((child, index) => {
    const previous = children[index - 1];
    const separate = isBlock(child) || isBlock(previous) ||
      (child.nodeType === 1 && previous?.nodeType === 1);
    return `${separate ? ' ' : ''}${displayedText(child, header)}`;
  }).join('').replace(/\s+/g, ' ').trim();
};

export const headerColumns = table => {
  const grid = [];
  Array.from(table.tHead?.rows || []).forEach((row, ri) => {
    grid[ri] ||= [];
    let ci = 0;
    Array.from(row.cells).forEach(cell => {
      while (grid[ri][ci] !== undefined) ci++;
      for (let r = ri; r < ri + cell.rowSpan; r++) {
        grid[r] ||= [];
        for (let c = ci; c < ci + cell.colSpan; c++) grid[r][c] = displayedText(cell, true);
      }
      ci += cell.colSpan;
    });
  });
  const width = Math.max(0, ...grid.map(row => row.length));
  return Array.from({ length: width }, (_, i) =>
    [...new Set(grid.map(row => row[i]).filter(Boolean))].join(' · '));
};
